import { Box, styled, keyframes } from '@mui/material';
import { useUserStore } from '@client/store';

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
`;

const Dot = styled('span')<{
  delay: number;
  color: string;
  size: number;
  duration: number;
}>(({ delay, color, size, duration }) => ({
  width: `${size}px`,
  height: `${size}px`,
  borderRadius: '50%',
  backgroundColor: color,
  display: 'inline-block',
  animation: `${bounce} ${duration}ms infinite ease-in-out`,
  animationDelay: `${delay}s`,
}));

export function TypingIndicator() {
  const { customization, typingIndicator } = useUserStore();
  const dotColor = customization.charTextColor || '#333';
  const size = typingIndicator.dotSize || 8;
  const duration = typingIndicator.animationDuration || 1400;
  const speed = (typingIndicator.speed || 250) / 1000;
  const repeat = typingIndicator.repeat || 3;

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={0.5}
      sx={{ width: 'fit-content' }}
    >
      {Array.from({ length: repeat }).map((_, i) => (
        <Dot
          key={i}
          delay={i * speed}
          color={dotColor}
          size={size}
          duration={duration}
        />
      ))}
    </Box>
  );
}
